import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {Person} from '../../person/person';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'sales-rep-dialog',
    templateUrl: 'sales-rep-dialog.component.html',
    styleUrls: ['./sales-rep-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogActions, MatButton]
})
export class SalesRepDialogComponent {
  dialogRef = inject<MatDialogRef<SalesRepDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  public isBusy: boolean = false;
  public person: Person;

  constructor
  () {
    const data = this.data;

    this.isBusy = true;
    this.person = data.rep as Person;
    this.isBusy = false;
  }

  public close(): void {
    this.dialogRef.close(false);
  }
}
